import type { IsoDate, IsoDateTime } from '@omnipresentgroup/design-system';

import type {
  PayrollProvider,
  PayrollProviderHistory,
} from '../payrollProviders';

export * from './api';

export enum LegalEntityType {
  EMPLOYER_OF_RECORD = 'employer-of-record',
  CONSULTING_ENTITY = 'consulting-entity',
  VIRTUAL_EMPLOYER = 'virtual-employer',
  PROFESSIONAL_EMPLOYMENT_ORGANISATION = 'professional-employment-organisation',
  PENDING = 'pending',
}

type BaseLegalEntity = {
  id: string;
  lspId: string;
  name: string;
  type: LegalEntityType;
  countryCode: string;
  parent?: LegalEntity;
  isOmniEntity: boolean;
  payrollProvider?: PayrollProvider;
  payrollProviderHistory?: PayrollProviderHistory[];
  profileUrl?: string;
  contactEmails?: string;
  isActive?: boolean;
  activeSince?: IsoDateTime;
  createdAt?: IsoDateTime;
  updatedAt?: IsoDateTime;
};

export type CutoffReportDayOverride = {
  id: string;
  cutoffReportDayId: string;
  cutoffReportDate: IsoDate;
  targetYearMonth: IsoDate;
  createdAt: IsoDateTime;
  createdBy: string;
};

export type CutoffReportDay = {
  id: string;
  cutoffReportDay: number;
  createdAt: IsoDateTime;
  cutoffReportDayOverrides?: CutoffReportDayOverride[];
};

export type LegalEntity = BaseLegalEntity & {
  cutoffReportDays?: CutoffReportDay[];
  nextCutoffDates?: IsoDateTime[];
};

export type LegalEntityListItem = BaseLegalEntity & {
  nextCutoffDate?: string | null;
};
